import { render, staticRenderFns } from "./InstructionsView.vue?vue&type=template&id=3d58070e&scoped=true&"
import script from "./InstructionsView.vue?vue&type=script&lang=js&"
export * from "./InstructionsView.vue?vue&type=script&lang=js&"
import style0 from "./InstructionsView.vue?vue&type=style&index=0&id=3d58070e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d58070e",
  null
  
)

export default component.exports